import React from 'react';

const statusToneClass = (tone) =>
  ['danger', 'warning', 'info', 'success'].includes(tone)
    ? `is-tone-${tone}`
    : 'is-tone-info';

export function DashboardFleetStatusFilterButton({
  active,
  icon,
  label,
  mobileLabel,
  value,
  helper,
  tone,
  onClick,
}) {
  const toneClass = statusToneClass(tone);
  const className = `dashboard-fleet-status-card ${toneClass}${active ? ' is-active' : ''}`;

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="dashboard-fleet-status-copy">
        <span className="dashboard-fleet-status-label">
          <span className="dashboard-fleet-status-label-full">{label}</span>
          <span className="dashboard-fleet-status-label-mobile">{mobileLabel || label}</span>
        </span>
        <span className="dashboard-fleet-status-value">{value}</span>
        <span className="dashboard-fleet-status-helper">{helper}</span>
      </span>
      <span className="dashboard-fleet-status-icon">{icon}</span>
    </button>
  );
}

export function DashboardMobileStatusFilterControl({ active, label, value, tone, onClick }) {
  const toneClass = statusToneClass(tone);
  const className = `dashboard-fleet-mobile-status-filter ${toneClass}${
    active ? ' is-active' : ''
  }`;

  return (
    <button type="button" className={className} onClick={onClick}>
      <span className="dashboard-fleet-mobile-status-filter-label">{label}</span>
      <span className="dashboard-fleet-mobile-status-filter-value">{value}</span>
    </button>
  );
}
